jQuery(document).ready(function($){

    var classController = new ScrollMagic.Controller();

    // var home_hero = new ScrollMagic.Scene({
    //     triggerElement: '#hero',
    //     duration: 0,
    //     triggerHook: 0.5,
    //     offset: 200
    // })
    // .setClassToggle('.home-hero', 'home-hero-animating')
    // .addTo(classController);


    var who_we_are = new ScrollMagic.Scene({
        triggerElement: '#who_we_are',
        duration: 0,
        triggerHook: 0.8,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.who-we-are', 'who-we-are-animating')
    .addTo(classController);

    var what_we_do = new ScrollMagic.Scene({
        triggerElement: '#what_we_do',
        duration: 0,
        triggerHook: 0.8,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.what-we-do', 'what-we-do-animating')
    .addTo(classController);


    var services = new ScrollMagic.Scene({
        triggerElement: '#services',
        duration: 0,
        triggerHook: 0.5,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.services', 'services-animating')
    .addTo(classController);


    var our_philosophy = new ScrollMagic.Scene({
        triggerElement: '#our_philosophy',
        duration: 0,
        triggerHook: 0.9,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.our-philosophy', 'our-philosophy-animating')
    .addTo(classController);


    var cta = new ScrollMagic.Scene({
        triggerElement: '#cta',
        duration: 0,
        triggerHook: 0.9,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.cta', 'cta-animating')
    .addTo(classController);

    var footer = new ScrollMagic.Scene({
        triggerElement: 'footer',
        duration: 0,
        triggerHook: 1,
        offset: 200,
        reverse: false
    })
    .setClassToggle('.footer-follow', 'footer-follow-animating')
    .addTo(classController);



});
